import { FC, HTMLAttributes, memo, Ref } from 'react';

export type AtchInputProps = Omit<HTMLAttributes<HTMLInputElement>, 'type' | 'style'> & {
  fwdRef?: Ref<HTMLInputElement>;
};

export const AtchInput: FC<AtchInputProps> = memo(({ fwdRef, ...rest }) => (
  <input ref={fwdRef} {...rest} type="file" accept="image/*" style={{ display: 'none' }} />
));
